export default class ReCAPTCHAv3 {
    static request = function (action, onSuccess, onError) {
        if (window.grecaptcha) {
            window.grecaptcha.ready(function () {
                const config = {
                    action: action,
                };

                try {
                    const publicKey = $('input[name="captcha_token"]').val();
                    const query = window.grecaptcha.execute(publicKey, config);

                    if (onSuccess) {
                        query.then(onSuccess);
                    }
                } catch (e) {
                    const message = e && e.message || 'Google reCAPTCHA request error.';

                    if (onError) {
                        onError(message);
                    }
                }
            });

            return;
        }
        
        if (onError) {
            onError('Google reCAPTCHA is not loaded correctly.');
        }
    };
};
